// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresPresetsGetBody = {
  leagueKey: string;
};

export type typeSquaresPresetsGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    leagueKey: string;
    allowsTies: boolean;
    defaultGridSize: number;
    gridSizes: number[];
    gamePresets: {
      presetKey: string;
      label: string;
      gridTypes: string[];
      isTeamFilterable: boolean;
      allowsZeroMatches: boolean;
    }[];
    axesPresets: {
      kind:
        "teamNames" | "winnerLoser" | "homeAway" | "teamOpponent" | "custom";
      label: string;
      gridTypes: string[];
    }[];
    checkpoints: {
      checkpointKey:
        | "q1"
        | "half"
        | "q3"
        | "p1"
        | "p2"
        | "after3"
        | "after5"
        | "after7"
        | "final";
      label: string;
      isAlwaysOn: boolean;
    }[];
  };
};

export type typeSquaresPresetsGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresPresetsGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresPresetsGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresPresetsGetBody = {
  type: "object",
  properties: { leagueKey: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["leagueKey"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresPresetsGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresPresetsGetBody);
  }

  return async function postSquaresPresetsGet(
    payload: typeSquaresPresetsGetBody,
  ): Promise<typeSquaresPresetsGetOutput200 | typeSquaresPresetsGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresPresetsGet" failed before calling the network. #25d800d86626`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#25d800d86626" },
        },
        data: null,
      } as typeSquaresPresetsGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/presets-get`,
      httpMethod: "POST",
      options,
    })) as typeSquaresPresetsGetOutput200 | typeSquaresPresetsGetOutput400;
  };
}
